import { resolveComponent as f, resolveDirective as u, withDirectives as m, openBlock as i, createBlock as n, withKeys as a, withModifiers as r, withCtx as l, createTextVNode as p, toDisplayString as b, resolveDynamicComponent as v, renderSlot as g } from "vue";
import { _ as y } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
import _ from "../button/button.js";
const h = {
  name: "EditorToolbarButton",
  components: {
    DtButton: _
  },
  props: {
    /**
     * Whether the button is active
     */
    isActive: {
      type: Boolean,
      default: !1
    },
    /**
     * Tooltip message
     */
    tooltipMessage: {
      type: String,
      required: !0
    },
    /**
     * Data QA attribute for testing
     */
    dataQA: {
      type: String,
      default: ""
    },
    /**
     * Tab index for keyboard navigation
     */
    tabindex: {
      type: Number,
      default: -1
    },
    /**
     * Icon component
     */
    icon: {
      type: Object,
      required: !0
    },
    /**
     * Button label text
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Click handler function
     */
    onClick: {
      type: Function,
      required: !0
    }
  },
  emits: [
    /**
     * Emitted when right arrow key is pressed
     */
    "shift-focus-right",
    /**
     * Emitted when left arrow key is pressed
     */
    "shift-focus-left"
  ]
};
function x(o, e, t, k, C, B) {
  const s = f("dt-button"), d = u("dt-tooltip");
  return m((i(), n(s, {
    ref: "buttonRef",
    active: t.isActive,
    "aria-label": t.tooltipMessage,
    "data-qa": t.dataQA,
    tabindex: t.tabindex,
    importance: "clear",
    kind: "muted",
    size: "xs",
    onClick: t.onClick,
    onKeydown: [
      e[0] || (e[0] = a(r((c) => o.$emit("shift-focus-right"), ["stop"]), ["right"])),
      e[1] || (e[1] = a(r((c) => o.$emit("shift-focus-left"), ["stop"]), ["left"]))
    ]
  }, {
    icon: l(() => [
      (i(), n(v(t.icon), { size: "200" })),
      g(o.$slots, "extra")
    ]),
    default: l(() => [
      p(" " + b(t.label), 1)
    ]),
    _: 3
  }, 8, ["active", "aria-label", "data-qa", "tabindex", "onClick"])), [
    [d, { message: t.tooltipMessage, placement: "top" }]
  ]);
}
const S = /* @__PURE__ */ y(h, [["render", x]]);
export {
  S as default
};
//# sourceMappingURL=EditorToolbarButton.js.map
